import { useEffect, useRef, useState } from 'react';
import { HeaderButton } from '../../../../components/header-button';
import { Search } from '../../../../components/search/search';
import { Outlet, useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { selectUser } from '../../../../slices/auth';
import {
  DisputeStatus,
  GameScreenshotType,
  SocketActions,
  UserRoles,
} from '../../../../utils/constants';
import {
  selectAnnouncements,
  selectChatrooms,
  selectMatchChats,
  setChatrooms,
} from '../../../../slices/inboxSlice';
import OgmaDashboardInboxMatchChat from '../../components/ogma-dashboard-inbox-match-chat';
import OgmaDashboardInboxDirectMessage from '../../components/omga-dashboard-inbox-direct-message';
import OgmaDashboardInboxAnnouncement from '../../components/omga-dashboard-inbox-announcement';

const OgmaDashboardInbox = () => {
  const curUser = useSelector(selectUser);
  const chatrooms = useSelector(selectChatrooms);
  const announcements = useSelector(selectAnnouncements);
  const matchChats = useSelector(selectMatchChats);
  const [activeRadioMessageFilter, setActiveRadioMessageFilter] = useState(1);

  const searchableColumnsLists: Record<number, { title: string; property: string }[]> = {
    1: [{ title: 'Subject', property: 'subject' }],
    2: [
      { title: 'Subject', property: 'subject' },
      { title: 'From', property: 'from' },
    ],
    3: [{ title: 'Season', property: 'season' }],
  };
  const [searchQuery, setSearchQuery] = useState(
    searchableColumnsLists[activeRadioMessageFilter][0].title,
  );
  const [search, setSearch] = useState({
    by: searchableColumnsLists[activeRadioMessageFilter][0].title.toLocaleLowerCase(),
    keyword: '',
  });
  useEffect(() => {
    setSearch({
      by: searchableColumnsLists[activeRadioMessageFilter][0].title.toLocaleLowerCase(),
      keyword: '',
    });
  }, [activeRadioMessageFilter]);

  const headerButtons = [
    {
      type: 'newMessage',
      label: 'New Message',
    },
    {
      type: 'newReschedule',
      label: 'New Reschedule',
    },
  ];

  const radioMessageFilters = [
    {
      id: 1,
      type: 'Announcements',
      label: 'Announcements',
      notificationNumber: announcements?.filter((a: any) =>
        a.Recipients?.some(
          (recipient: any) =>
            recipient.userId === curUser.id &&
            new Date(recipient.lastReadDate).getTime() < new Date(a.send_time).getTime(),
        ),
      ).length,
    },
    {
      id: 2,
      type: 'DirectMessages',
      label: 'Direct Messages',
      notificationNumber: chatrooms?.flatMap((chatroom: any) => {
        const chatroomUser = chatroom.ChatroomUsers.find((user: any) => user.userId === curUser.id);
        const lastReadDate = chatroomUser?.lastReadDate;

        return chatroom.messages.filter((message: any) => {
          if (!lastReadDate) return true;
          return new Date(message.time) > new Date(lastReadDate);
        });
      }).length,
    },
    {
      id: 3,
      type: 'MatchChat',
      label: 'Match Chats',
      notificationNumber: matchChats
        ?.filter((d: any) => {
          return (
            d.disputes.filter(
              (d: any) =>
                d.status === DisputeStatus.NotChecked && d.type === GameScreenshotType.ChatDispute,
            ).length > 0
          );
        })
        ?.reduce((total: number, matchChat: any) => total + matchChat.unreadMatchChats, 0),
    },
  ];

  return (
    <div>
      <div className='flex justify-between gap-5 content-center items-center'>
        <div className='flex gap-5'>
          {headerButtons.map((button) => (
            <HeaderButton key={button.type} type={button.type} />
          ))}
        </div>
        <Search
          setQuery={setSearchQuery}
          filterList={searchableColumnsLists[activeRadioMessageFilter]}
          search={search}
          setSearch={setSearch}
        />
      </div>
      <div className='border-b-2 my-4'></div>
      <div className='flex justify-start gap-5'>
        {radioMessageFilters.map((filter) => (
          <div
            key={filter.type}
            attr-count={matchChats ? filter.notificationNumber || null : '...'}
            className={`px-4 py-1 border-1 text-sm rounded cursor-pointer ${
              activeRadioMessageFilter === filter.id ? 'border-red-500' : 'border-gray-300'
            } notification-show before:!-top-2 before:!-right-2 before:!border-fen-red before:!bg-white before:!text-fen-red`}
            onClick={() => setActiveRadioMessageFilter(filter.id)}
          >
            {filter.label}
          </div>
        ))}
      </div>
      {(() => {
        switch (activeRadioMessageFilter) {
          case 1:
            return <OgmaDashboardInboxAnnouncement />;
          case 2:
            return <OgmaDashboardInboxDirectMessage />;
          case 3:
            return <OgmaDashboardInboxMatchChat />;
          default:
            return null;
        }
      })()}
      <Outlet />
    </div>
  );
};

export default OgmaDashboardInbox;
